import useAddLocation from "@babackapp/private-api-client/client/use-add-shop-location";
import type {
	CreateShopLocationDto,
	ShopLocationDto,
} from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from "@babackapp/ui/components/dialog";
import { type PropsWithChildren, useCallback } from "react";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useBoolean } from "@/hooks/use-boolean";
import AddLocationForm from "./add-location-form";

export const AddLocationDialog = ({ children }: PropsWithChildren) => {
	const open = useBoolean(false);
	const t = useTranslation();
	const { data: shop } = useCurrentShopSuspense();
	const { mutateAsync: addLocation } = useAddLocation(shop);
	const onSubmit = useCallback(
		(data: ShopLocationDto) => {
			addLocation(data as CreateShopLocationDto).then(open.setFalse);
		},
		[addLocation, shop.id],
	);

	return (
		<Dialog open={open.value} onOpenChange={open.setValue}>
			<DialogTrigger asChild={true}>{children}</DialogTrigger>
			<DialogContent className="pt-10">
				<DialogHeader>
					<DialogTitle>{t("settings.shipping.addLocation")}</DialogTitle>
					<DialogDescription>
						{t("settings.shipping.addLocationDescription")}
					</DialogDescription>
				</DialogHeader>
				<AddLocationForm onSubmit={onSubmit} />
			</DialogContent>
		</Dialog>
	);
};
